import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import { api, errMsg, useSeo, fmtDate } from "../lib/api";
import { PageHero, Section, Badge } from "../components/Common";
import ApplyForm from "../components/ApplyForm";

function Track() {
  const [f, setF] = useState({ application_no: "", email: "" });
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.preventDefault();
    setErr(""); setRes(null); setBusy(true);
    try { setRes((await api.post("/applications/track", f)).data); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <div id="takip" className="bg-zinc-950 text-white p-6 sm:p-8" data-testid="track-box">
      <h2 className="font-black text-xl">Başvuru takibi</h2>
      <p className="text-sm text-zinc-400 mt-1">Başvuru numaranız ve e-posta adresinizle durumunu sorgulayın.</p>
      <form onSubmit={go} className="mt-5 grid gap-3">
        <input className="field !bg-zinc-900 !border-zinc-700 text-white" placeholder="ADA-2026-00001" value={f.application_no} onChange={(e) => setF({ ...f, application_no: e.target.value })} required data-testid="track-number" aria-label="Başvuru numarası" />
        <input className="field !bg-zinc-900 !border-zinc-700 text-white" type="email" placeholder="E-posta adresiniz" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required data-testid="track-email" aria-label="E-posta" />
        <button className="btn-red" disabled={busy} data-testid="track-submit-btn">{busy ? <Loader2 size={16} className="animate-spin" /> : <Search size={16} />}Sorgula</button>
      </form>
      {err && <p className="mt-3 text-sm text-red-300" data-testid="track-error">{err}</p>}
      {res && (
        <div className="mt-4 border border-zinc-700 p-4 text-sm" data-testid="track-result">
          <p className="font-bold">{res.application_no} – {res.course_title}</p>
          <p className="mt-2">Durum: <Badge tone="red" testid="track-status">{res.status_label}</Badge></p>
          <p className="mt-2 text-zinc-400">Başvuru tarihi: {fmtDate(res.created_at)}</p>
        </div>
      )}
    </div>
  );
}

export default function Apply() {
  const [params] = useSearchParams();
  const [courseId, setCourseId] = useState("");
  useSeo("Kurs Başvurusu", "Özel güvenlik kurs başvurusu – Kuşadası / Aydın. Online ön başvuru formu ve başvuru takibi.");
  useEffect(() => {
    const d = params.get("donem");
    if (d) api.get("/events").then((r) => setCourseId(r.data.find((e) => e.id === d)?.course_id || ""));
  }, [params]);
  return (
    <>
      <PageHero eyebrow="Online Başvuru" title="Kurs Başvurusu" text="Ön başvurunuzu iletin, kurumumuz sizinle iletişime geçsin. Başvuru numaranızla durumunu takip edebilirsiniz." />
      <Section>
        <div className="grid gap-6 lg:grid-cols-[2fr_1fr] items-start">
          <div className="card-ada p-6 sm:p-8"><ApplyForm key={courseId} courseId={courseId} /></div>
          <Track />
        </div>
      </Section>
    </>
  );
}
